import styled from '@emotion/styled'
import { WebLink } from '@news-mono/web-common'
import { textMixin } from '../../../mixins/TextMixin/TextMixin'
import { breakpoint, calcRem, TheNightlyTheme } from '../../../__styling'

export const PuzzleLinkContainer = styled.div({
    display: 'flex',
    flexDirection: 'column',
    gap: calcRem(40),

    [breakpoint('sm')]: {
        flexDirection: 'row',
    },
})

export const Title = styled.h2(({ theme }) => [
    {
        margin: 0,
    },
    textMixin(theme as TheNightlyTheme, 'section-header'),
])

export const TitleDescription = styled.div(({ theme }) => [
    {
        color: theme.colors.text.tertiary,
    },
    textMixin(theme as TheNightlyTheme, 'body-alt'),
])

export const PuzzleLink = styled(WebLink)({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: calcRem(8),

    // Remove default link styles.
    color: 'inherit',
    textDecoration: 'inherit',
})

export const PuzzleTitle = styled.div(({ theme }) =>
    textMixin(theme as TheNightlyTheme, 'subheading'),
)
export const PuzzleDate = styled.div(({ theme }) => [
    {
        color: theme.colors.text.tertiary,
    },
    textMixin(theme as TheNightlyTheme, 'body-alt'),
])

export const TextContainer = styled.div({
    display: 'flex',
    flexDirection: 'column',
    gap: calcRem(8),
    alignSelf: 'flex-start',
})
